import "core-js/modules/es.array.concat.js";
import { UserRole } from "./UserContext";
export var getContentUIRootUrl = function getContentUIRootUrl() {
  return window.CONTENT_UI_URL;
}; // currently only set for the admin spa

export var getSimsUrl = function getSimsUrl() {
  var rootUrl = getContentUIRootUrl();
  if (!rootUrl) {
    return '';
  }
  return "".concat(rootUrl, "/content/programs");
};
export var getGradeConversionUrl = function getGradeConversionUrl() {
  var rootUrl = getContentUIRootUrl();
  if (!rootUrl) {
    return '';
  }
  return "".concat(rootUrl, "/content/grade-conversion");
};
export function getProgramPath(schoolSlug, programSlug) {
  if (!schoolSlug || !programSlug) {
    return '';
  }
  return "/schools/".concat(schoolSlug, "/programs/").concat(programSlug);
}
export function getEditProgramPath(schoolGroupId, schoolId, programId) {
  var simsUrl = getSimsUrl();
  if (!simsUrl || !schoolGroupId || !schoolId || !programId) {
    return '';
  }
  return "".concat(simsUrl, "?school_group_id=").concat(schoolGroupId, "&school_id=").concat(schoolId, "&program_id=").concat(programId);
}
export function getSchoolCommissionsLink(role) {
  if (role !== UserRole.AGENT) {
    return '';
  }
  return '/profile#school-commissions';
}
export function getApplyBoostReferralPath(user) {
  var userId = user === null || user === void 0 ? void 0 : user.id;
  return userId ? "/partners/".concat(userId, "/applyboost") : '';
}
export function getAgencyRegistrationRequestsPagePath() {
  return "/agency_registration_requests";
}
export function getAgencyChangeRequestsPagePath() {
  return "/agency_change_requests";
}
export function getAgencyProfilePath(agentInformationId) {
  return "/agent_informations/".concat(agentInformationId, "/agency_profile");
}
export function getAgencyChangeRequestsApiPath() {
  return '/api/rpj-bff/agency_change_requests';
}